import React from 'react';
// We only need to import this type from history package as react-router doesn't re-export that.
// No need to include that to direct dependencies.
// eslint-disable-next-line import/no-extraneous-dependencies
import { Location } from 'history';
import { InjectedRouter } from 'react-router';
import { ReactRouterProvider, Params } from 'react-router-dom';

export type SelectorProps = {
    isLoggedIn: boolean;
};

export type AuthPackageWrapProps = {
    children: React.ReactElement;
    className?: string;
    location: Location;
    router: InjectedRouter;
    params: Params;
};

const AuthPackageWrap = ({
    children,
    location,
    router,
    params,
}: AuthPackageWrapProps & SelectorProps): JSX.Element => (
    <ReactRouterProvider location={location} router={router} params={params}>
        {children}
    </ReactRouterProvider>
);

export default AuthPackageWrap;
